/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ " PrizeCol, IntroList ": NonNullable<unknown>, "[169]": NonNullable<unknown>, "[170, 171, 172, 173, 174]": NonNullable<unknown>, "[164, 165, 166, 167, 168]": NonNullable<unknown> }} Bakery_Event_RuleInputs */

const en_bakery_event_rule = /** @type {(inputs: Bakery_Event_RuleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`import ${i?.[" PrizeCol, IntroList "]} from '../components'

### How it Works
<IntroList />

### Event Period
* Event period: May 27, 2026, 00:00 to June 25, 2026, 23:59 (UTC+0).
* Daily countdowns, task resets, and reward availability are based on UTC+0.
* After the event ends, unclaimed cake boxes and unused stamps will expire. The system will not claim them automatically.

### Daily Cake Boxes
* Cake boxes can be claimed after completing 60 minutes of focus for that day. This includes both the free cake box and the Plus Bonus Cake Box.
* Daily Extra Cake Boxes can only be purchased on the current day. Past dates cannot be purchased retroactively. 
* Cakes earned during the event are permanently unlocked and can still be used after the event ends.
* After subscribing to Forest Plus during the event, you can return to dates where you completed 60 minutes of focus and claim the Plus Bonus Cake Box for those dates.
* Unclaimed Bonus Cake Boxes earned while your Plus membership was active can still be claimed during the event, even after your membership expires.

### Stamps and Exchange Shop
* When you open a cake box, duplicate cakes turn into stamps.
* Stamps can be used to redeem missing cakes.
* Plus members can use stamps to redeem Returning Trees during the event.

### Notes
* Each event day resets at 00:00 (UTC+0). If a focus session crosses the daily reset time, its focus time will not count toward the event.
* Cheating, abusing bugs, or using other improper methods is prohibited. Violations may result in disqualification from the event or removal of rewards.
* Forest reserves the right to adjust, suspend, or terminate the event and to make the final interpretation of the event rules.

### Reward Rates
The following rates apply to all cake boxes. Each cake box grants 1 reward. If you receive a duplicate reward, it will be converted into stamps according to the table below:


| Reward | Styles | Rate per Style | Stamp Conversion |
| --- | --- | --- | --- |
| <PrizeCol gids=${i?.["[169]"]} label="12th Anniversary Cake Tree" /> | 1 | 4.5% | 30 |
| <PrizeCol gids=${i?.["[170, 171, 172, 173, 174]"]} label="12th Anniversary Cupcakes" /> | 5 | 9.55% | 12 |
| <PrizeCol gids=${i?.["[164, 165, 166, 167, 168]"]} label="12th Anniversary Macarons" /> | 5 | 9.55% | 12 |`)
};

const ar_bakery_event_rule = /** @type {(inputs: Bakery_Event_RuleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`import ${i?.[" PrizeCol, IntroList "]} from '../components'

### كيف يعمل الأمر<IntroList />

### فترة الحدث
* فترة الحدث: من 27 مايو 2026 الساعة 00:00 إلى 25 يونيو 2026 الساعة 23:59 (UTC+0).
* تعتمد عمليات العد التنازلي اليومية، وإعادة تعيين المهام، وتوفر المكافآت على توقيت UTC+0.
* بعد انتهاء الحدث، ستنتهي صلاحية صناديق الكعك غير المطالب بها والطوابع غير المستخدمة. لن يقوم النظام بالمطالبة بها تلقائيًا.

### صناديق الكعك اليومية
* يمكن المطالبة بصناديق الكعك بعد إكمال 60 دقيقة من التركيز في ذلك اليوم. يتضمن ذلك كلاً من صندوق الكعك المجاني وصندوق كعك مكافأة Plus.
* يمكن شراء صناديق الكعك الإضافية اليومية في اليوم الحالي فقط. لا يمكن شراء التواريخ السابقة بأثر رجعي.
* الكعكات المكتسبة خلال الحدث يتم إلغاء قفلها بشكل دائم ويمكن استخدامها حتى بعد انتهاء الحدث.
* بعد الاشتراك في Forest Plus خلال الحدث، يمكنك العودة إلى التواريخ التي أكملت فيها 60 دقيقة من التركيز والمطالبة بصندوق كعك مكافأة Plus لتلك التواريخ.
* صناديق كعك المكافأة غير المطالب بها والتي تم اكتسابها أثناء نشاط عضوية Plus الخاصة بك يمكن المطالبة بها خلال الحدث، حتى بعد انتهاء صلاحية عضويتك.

### الطوابع ومتجر الاستبدال
* عند فتح صندوق الكعك، تتحول الكعكات المكررة إلى طوابع.
* يمكن استخدام الطوابع لاستبدال الكعكات المفقودة.
* يمكن لأعضاء Plus استخدام الطوابع لاستبدال الأشجار العائدة خلال الحدث.

### ملاحظات
* يبدأ كل يوم من أيام الحدث في الساعة 00:00 (UTC+0). إذا تجاوزت جلسة التركيز وقت تغيّر اليوم، فلن يتم احتساب وقت التركيز ضمن الحدث.
* يُحظر الغش أو استغلال الأخطاء أو استخدام أساليب أخرى غير لائقة. قد تؤدي المخالفات إلى الاستبعاد من الحدث أو إزالة المكافآت.
* تحتفظ Forest بالحق في تعديل الحدث أو تعليقه أو إنهائه وتفسير قواعد الحدث بشكل نهائي.

### نسب المكافآت
تنطبق النسب التالية على جميع صناديق الكعك. يمنح كل صندوق كعك مكافأة واحدة. إذا حصلت على مكافأة مكررة، فسيتم تحويلها إلى طوابع وفقًا للجدول أدناه:


| المكافأة | الأنماط | النسبة لكل نمط | تحويل الطوابع |
| --- | --- | --- | --- |
| <PrizeCol gids=${i?.["[169]"]} label="الذكرى السنوية الثانية عشر لشجرة الكيك" /> | 1 | 4.5% | 30 |
| <PrizeCol gids=${i?.["[170, 171, 172, 173, 174]"]} label="" /> | 5 | 9.55% | 12 |
| <PrizeCol gids=${i?.["[164, 165, 166, 167, 168]"]} label="" /> | 5 | 9.55% | 12 |`)
};

const de_bakery_event_rule = /** @type {(inputs: Bakery_Event_RuleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`import ${i?.[" PrizeCol, IntroList "]} from '../components'

### So funktioniert es<IntroList />

### Event-Zeitraum
* Event-Zeitraum: 27. Mai 2026, 00:00 Uhr bis 25. Juni 2026, 23:59 Uhr (UTC+0).
* Tägliche Countdowns, das Zurücksetzen von Aufgaben und die Verfügbarkeit von Belohnungen basieren auf UTC+0.
* Nach Ende des Events verfallen nicht abgeholte Kuchenboxen und ungenutzte Stempel. Das System holt sie nicht automatisch ab.

### Tägliche Kuchenboxen
* Kuchenboxen können abgeholt werden, nachdem am jeweiligen Tag 60 Minuten Fokus abgeschlossen wurden. Dies beinhaltet sowohl die kostenlose Kuchenbox als auch die Plus-Bonus-Kuchenbox.
* Tägliche Extra-Kuchenboxen können nur am aktuellen Tag erworben werden. Vergangene Termine können nicht rückwirkend gekauft werden.
* Während des Events verdiente Kuchen sind dauerhaft freigeschaltet und können auch nach Ende des Events weiterhin verwendet werden.
* Nach dem Abonnieren von Forest Plus während des Events kannst du zu Daten zurückkehren, an denen du 60 Minuten Fokus abgeschlossen hast, und die Plus-Bonus-Kuchenbox für diese Tage abholen.
* Nicht abgeholte Bonus-Kuchenboxen, die verdient wurden, während deine Plus-Mitgliedschaft aktiv war, können während des Events immer noch abgeholt werden, selbst wenn deine Mitgliedschaft abgelaufen ist.

### Stempel und Tauschladen
* Wenn du eine Kuchenbox öffnest, werden doppelte Kuchen in Stempel umgewandelt.
* Stempel können verwendet werden, um fehlende Kuchen einzulösen.
* Plus-Mitglieder können Stempel verwenden, um während des Events wiederkehrende Bäume einzulösen.

### Hinweise
* Jeder Event-Tag beginnt um 00:00 Uhr (UTC+0). Wenn eine Fokussitzung über diesen Tageswechsel hinausgeht, wird die Fokuszeit nicht für das Event angerechnet.
* Cheaten, das Ausnutzen von Fehlern oder die Verwendung anderer unangemessener Methoden ist verboten. Verstöße können zum Ausschluss vom Event oder zum Entzug von Belohnungen führen.
* Forest behält sich das Recht vor, das Event anzupassen, auszusetzen oder zu beenden und die Eventregeln endgültig auszulegen.

### Belohnungsraten
Die folgenden Raten gelten für alle Kuchenboxen. Jede Kuchenbox gewährt 1 Belohnung. Wenn du eine doppelte Belohnung erhältst, wird diese gemäß der folgenden Tabelle in Stempel umgewandelt:


| Belohnung | Stile | Rate pro Stil | Stempel-Umwandlung |
| --- | --- | --- | --- |
| <PrizeCol gids=${i?.["[169]"]} label="Tortenbaum zum 12. Jahrestag" /> | 1 | 4.5% | 30 |
| <PrizeCol gids=${i?.["[170, 171, 172, 173, 174]"]} label="" /> | 5 | 9.55% | 12 |
| <PrizeCol gids=${i?.["[164, 165, 166, 167, 168]"]} label="" /> | 5 | 9.55% | 12 |`)
};

const es_bakery_event_rule = /** @type {(inputs: Bakery_Event_RuleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`import ${i?.[" PrizeCol, IntroList "]} from '../components'

### Cómo funciona<IntroList />

### Periodo del evento
* Periodo del evento: del 27 de mayo de 2026 a las 00:00 al 25 de junio de 2026 a las 23:59 (UTC+0).
* Las cuentas regresivas diarias, los reinicios de tareas y la disponibilidad de recompensas se basan en UTC+0.
* Una vez finalizado el evento, las cajas de pasteles no reclamadas y los sellos no utilizados caducarán. El sistema no los reclamará automáticamente.

### Cajas de pasteles diarias
* Las cajas de pasteles se pueden reclamar después de completar 60 minutos de concentración en ese día. Esto incluye tanto la caja de pasteles gratuita como la caja de pasteles de bonificación Plus.
* Las cajas de pasteles adicionales diarias solo se pueden comprar en el día actual. Las fechas pasadas no se pueden comprar de forma retroactiva.
* Los pasteles obtenidos durante el evento se desbloquean de forma permanente y se pueden seguir usando después de que termine el evento.
* Tras suscribirte a Forest Plus durante el evento, puedes volver a las fechas en las que completaste 60 minutos de concentración y reclamar la caja de pasteles de bonificación Plus para esas fechas.
* Las cajas de pasteles de bonificación no reclamadas que hayas obtenido mientras tu suscripción Plus estaba activa se pueden seguir reclamando durante el evento, incluso después de que la suscripción expire.

### Sellos y tienda de canje
* Al abrir una caja de pasteles, los pasteles duplicados se convierten en sellos.
* Los sellos se pueden usar para canjear los pasteles que te falten.
* Los miembros Plus pueden usar sellos para canjear los árboles de regreso durante el evento.

### Notas
* Cada día del evento comienza a las 00:00 (UTC+0). Si una sesión de concentración se extiende más allá de este cambio de día, el tiempo de concentración no se contará para el evento.
* Está prohibido hacer trampas, abusar de errores o usar otros métodos indebidos. Las infracciones pueden dar lugar a la descalificación del evento o a la retirada de las recompensas.
* Forest se reserva el derecho de ajustar, suspender o dar por terminado el evento, así como de realizar la interpretación final de las reglas del mismo.

### Probabilidades de recompensa
Las siguientes probabilidades se aplican a todas las cajas de pasteles. Cada caja de pasteles otorga 1 recompensa. Si recibes una recompensa duplicada, se convertirá en sellos según la siguiente tabla:


| Recompensa | Estilos | Probabilidad por estilo | Conversión en sellos |
| --- | --- | --- | --- |
| <PrizeCol gids=${i?.["[169]"]} label="Árbol de pastel del 12º cumpleaños" /> | 1 | 4.5% | 30 |
| <PrizeCol gids=${i?.["[170, 171, 172, 173, 174]"]} label="" /> | 5 | 9.55% | 12 |
| <PrizeCol gids=${i?.["[164, 165, 166, 167, 168]"]} label="" /> | 5 | 9.55% | 12 |`)
};

const fr_bakery_event_rule = /** @type {(inputs: Bakery_Event_RuleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`import ${i?.[" PrizeCol, IntroList "]} from '../components'

### Comment ça marche<IntroList />

### Période de l'événement
* Période de l'événement : du 27 mai 2026 à 00h00 au 25 juin 2026 à 23h59 (UTC+0).
* Les comptes à rebours quotidiens, les réinitialisations de tâches et la disponibilité des récompenses sont basés sur le fuseau horaire UTC+0.
* Après la fin de l'événement, les boîtes à gâteaux non réclamées et les timbres inutilisés expireront. Le système ne les réclamera pas automatiquement.

### Boîtes à gâteaux quotidiennes
* Les boîtes à gâteaux peuvent être réclamées après avoir effectué 60 minutes de concentration pour la journée. Cela inclut la boîte à gâteaux gratuite et la boîte à gâteaux bonus Plus.
* Les boîtes à gâteaux supplémentaires quotidiennes ne peuvent être achetées que le jour même. Les dates passées ne peuvent pas être achetées rétroactivement.
* Les gâteaux gagnés pendant l'événement sont déverrouillés de manière permanente et peuvent toujours être utilisés après la fin de l'événement.
* Après vous être abonné à Forest Plus pendant l'événement, vous pouvez revenir aux dates où vous avez effectué 60 minutes de concentration et réclamer la boîte à gâteaux bonus Plus pour ces dates.
* Les boîtes à gâteaux bonus non réclamées gagnées pendant que votre abonnement Plus était actif peuvent toujours être réclamées pendant l'événement, même après l'expiration de votre abonnement.

### Timbres et boutique d'échange
* Lorsque vous ouvrez une boîte à gâteaux, les gâteaux en double se transforment en timbres.
* Les timbres peuvent être utilisés pour obtenir les gâteaux manquants.
* Les membres Plus peuvent utiliser les timbres pour obtenir les arbres de retour pendant l'événement.

### Remarques
* Chaque jour de l'événement commence à 00h00 (UTC+0). Si une session de concentration se prolonge au-delà de ce changement de jour, le temps de concentration ne sera pas comptabilisé pour l'événement.
* La triche, l'abus de bugs ou l'utilisation d'autres méthodes inappropriées sont interdits. Les violations peuvent entraîner la disqualification de l'événement ou le retrait des récompenses.
* Forest se réserve le droit d'ajuster, de suspendre ou de mettre fin à l'événement et de fournir l'interprétation finale des règles de l'événement.

### Taux de récompense
Les taux suivants s'appliquent à toutes les boîtes à gâteaux. Chaque boîte à gâteaux accorde 1 récompense. Si vous recevez une récompense en double, elle sera convertie en timbres selon le tableau ci-dessous :


| Récompense | Styles | Taux par style | Conversion en timbres |
| --- | --- | --- | --- |
| <PrizeCol gids=${i?.["[169]"]} label="Arbre Gâteau du 12e anniversaire" /> | 1 | 4.5% | 30 |
| <PrizeCol gids=${i?.["[170, 171, 172, 173, 174]"]} label="" /> | 5 | 9.55% | 12 |
| <PrizeCol gids=${i?.["[164, 165, 166, 167, 168]"]} label="" /> | 5 | 9.55% | 12 |`)
};

const it_bakery_event_rule = /** @type {(inputs: Bakery_Event_RuleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`import ${i?.[" PrizeCol, IntroList "]} from '../components'

### Come funziona<IntroList />

### Periodo dell'evento
* Periodo dell'evento: dal 27 maggio 2026 alle 00:00 al 25 giugno 2026 alle 23:59 (UTC+0).
* I conti alla rovescia giornalieri, il ripristino delle attività e la disponibilità dei premi si basano su UTC+0.
* Al termine dell'evento, le scatole di torte non riscattate e i timbri non utilizzati scadranno. Il sistema non li riscatterà automaticamente.

### Scatole di torte giornaliere
* Le scatole di torte possono essere riscattate dopo hav completato 60 minuti di concentrazione per quel giorno. Ciò include sia la scatola di torte gratuita che la scatola di torte bonus Plus.
* Le scatole di torte extra giornaliere possono essere acquistate solo nel giorno corrente. Non è possibile acquistare retroattivamente date passate.
* Le torte ottenute durante l'evento sono sbloccate in modo permanente e possono essere utilizzate anche dopo la fine dell'evento.
* Dopo esserti iscritto a Forest Plus durante l'evento, puoi tornare alle date in cui hai completato 60 minuti di concentrazione e riscattare la scatola di torte bonus Plus per quelle date.
* Le scatole di torte bonus non riscattate ottenute mentre la tua iscrizione Plus era attiva possono ancora essere riscattate durante l'evento, anche dopo la scadenza dell'iscrizione.

### Timbri e negozio di scambio
* Quando apri una scatola di torte, le torte doppie si trasformano in timbri.
* I timbri possono essere utilizzati per riscattare le torte mancanti.
* I membri Plus possono utilizzare i timbri per riscattare gli alberi di ritorno durante l'evento.

### Note
* Ogni giorno dell'evento inizia alle 00:00 (UTC+0). Se una sessione di concentrazione si estende oltre questo cambio di giorno, il tempo di concentrazione non verrà conteggiato per l'evento.
* È vietato imbrogliare, abusare di bug o utilizzare altri metodi impropri. Le violazioni possono comportare la squalifica dall'evento o la rimozione dei premi.
* Forest si riserva il diritto di modificare, sospendere o interrompere l'evento e di dare l'interpretazione finale delle regole dell'evento.

### Probabilità dei premi
Le seguenti probabilità si applicano a todas le scatole di torte. Ciascuna scatola di torte assegna 1 premio. Se ricevi un premio doppio, verrà convertito in timbri secondo la tabella seguente:


| Premio | Stili | Probabilità per stile | Conversione in timbri |
| --- | --- | --- | --- |
| <PrizeCol gids=${i?.["[169]"]} label="Albero Torta del 12° Anniversario" /> | 1 | 4.5% | 30 |
| <PrizeCol gids=${i?.["[170, 171, 172, 173, 174]"]} label="" /> | 5 | 9.55% | 12 |
| <PrizeCol gids=${i?.["[164, 165, 166, 167, 168]"]} label="" /> | 5 | 9.55% | 12 |`)
};

const ja_bakery_event_rule = /** @type {(inputs: Bakery_Event_RuleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`import ${i?.[" PrizeCol, IntroList "]} from '../components'

### イベント方法<IntroList />

### イベント期間
* イベント期間：2026年5月27日 00:00 から 2026年6月25日 23:59 (UTC+0) まで。
* 毎日のカウントダウン、タスクのリセット、報酬の受け取り可能時間はすべて UTC+0 に基づきます。
* イベント終了後、未受け取りのケーキボックスおよび未使用のスタンプは失効します。システムによる自動受け取りは行われません。

### デイリーケーキボックス
* ケーキボックスは、その日に60分間の集中を完了した後に受け取ることができます。これには、無料의ケーキボックスとPlusボーナスケーキボックスの両方が含まれます。
* デイリー追加ケーキボックスは当日のみ購入可能です。過去の日付に遡って購入することはできません。
* イベント期間中に獲得したケーキは永久に解放され、イベント終了後も引き続き使用できます。
* イベント期間中にForest Plusに登録すると、60分間の集中を完了した過去の日付に戻って、その日のPlusボーナスケーキボックスを受け取ることができます。
* Plus会員期間中に獲得条件を満たしたものの、未受け取りのボーナスケーキボックスは、会員期限が切れた後でもイベント期間中であれば受け取ることができます。

### スタンプと交換ショップ
* ケーキボックスを開けた際、重複したケーキはスタンプに変換されます。
* スタンプは未獲得のケーキと交換するために使用できます。
* Plus会員は、イベント期間中にスタンプを使用して復刻樹木を交換できます。

### 注意事項
* イベントの日付は毎日 00:00 (UTC+0) に切り替わります。集中セッションが日付の切り替え時刻をまたいだ場合、その集中時間はイベントにカウントされません。
* 不正行為、バグの悪用、その他の不適切な方法の使用は禁止されています。違反した場合、イベントへの参加資格の剥奪や報酬の回収が行われることがあります。
* Forestは、イベント内容の調整、一時停止、終了、およびイベントルールの最終的な解釈権を留保します。

### 報酬の確率
以下の確率はすべてのケーキボックスに適用されます。各ケーキボックスから1つの報酬が手に入ります。すでに所持している重複報酬を受け取った場合、以下の表に従ってスタンプに変換されます。


| 報酬内容 | スタイル数 | 1スタイルあたりの確率 | スタンプ変換 |
| --- | --- | --- | --- |
| <PrizeCol gids=${i?.["[169]"]} label="12周年記念ケーキの木" /> | 1 | 4.5% | 30 |
| <PrizeCol gids=${i?.["[170, 171, 172, 173, 174]"]} label="" /> | 5 | 9.55% | 12 |
| <PrizeCol gids=${i?.["[164, 165, 166, 167, 168]"]} label="" /> | 5 | 9.55% | 12 |`)
};

const ko_bakery_event_rule = /** @type {(inputs: Bakery_Event_RuleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`import ${i?.[" PrizeCol, IntroList "]} from '../components'

### 이벤트 방법<IntroList />

### 이벤트 기간
* 이벤트 기간: 2026년 5월 27일 00:00 ~ 2026년 6월 25일 23:59 (UTC+0).
* 일일 카운트다운, 미션 초기화 및 보상 수령 가능 시간은 UTC+0을 기준으로 합니다.
* 이벤트가 종료되면 수령하지 않은 케이크 상자와 사용하지 않은 스탬프는 소멸됩니다. 시스템에서 자동으로 수령해 주지 않습니다.

### 일일 케이크 상자
* 케이크 상자는 당일 60분의 집중을 완료한 후 수령할 수 있습니다. 여기에는 무료 케이크 상자와 Plus 보너스 케이크 상자가 모두 포함됩니다.
* 일일 추가 케이크 상자는 당일에만 구매할 수 있습니다. 지나간 날짜의 상자는 소급 구매할 수 없습니다.
* 이벤트 기간 동안 획득한 케이크는 영구적으로 잠금 해제되며, 이벤트가 종료된 후에도 계속 사용할 수 있습니다.
* 이벤트 기간 중 Forest Plus를 구독하면, 60분 집중을 완료했던 이전 날짜로 돌아가 해당 날짜의 Plus 보너스 케이크 상자를 수령할 수 있습니다.
* Plus 회원 자격이 유지되는 동안 획득 조건을 충족했으나 수령하지 않은 보너스 케이크 상자는, 회원 자격이 만료된 후라도 이벤트 기간 내라면 수령할 수 있습니다.

### 스탬프 및 교환 상점
* 케이크 상자를 개봉할 때, 중복된 케이크는 스탬프로 전환됩니다.
* 스탬프를 사용하여 수집하지 못한 케이크를 교환할 수 있습니다.
* Plus 회원은 이벤트 기간 동안 스탬프를 사용하여 돌아온 나무를 교환할 수 있습니다.

### 주의 사항
* 이벤트 날짜는 매일 00:00(UTC+0)에 변경됩니다. 집중 세션이 날짜 변경 시점을 넘기는 경우, 해당 집중 시간은 이벤트에 집계되지 않습니다.
* 부정행위, 버그 악용 또는 기타 부적절한 방법의 사용은 금지됩니다. 위반 시 이벤트 참가 자격이 박탈되거나 보상이 회수될 수 있습니다.
* Forest는 이벤트 내용을 조정, 일시 중지 또는 종료할 권리와 이벤트 규칙에 대한 최종 해석권을 보유합니다.

### 보상 확률
다음 확률은 모든 케이크 상자에 적용됩니다. 각 케이크 상자 개봉 시 1개의 보상을 획득합니다. 이미 보유한 중복 보상을 획득하는 경우, 아래 표에 따라 스탬프로 변환됩니다.


| 보상 내용 | 종류 | 종류별 확률 | 스탬프 변환 |
| --- | --- | --- | --- |
| <PrizeCol gids=${i?.["[169]"]} label="12주년 기념 케이크 나무" /> | 1 | 4.5% | 30 |
| <PrizeCol gids=${i?.["[170, 171, 172, 173, 174]"]} label="" /> | 5 | 9.55% | 12 |
| <PrizeCol gids=${i?.["[164, 165, 166, 167, 168]"]} label="" /> | 5 | 9.55% | 12 |`)
};

const pt_br_bakery_event_rule = /** @type {(inputs: Bakery_Event_RuleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`import ${i?.[" PrizeCol, IntroList "]} from '../components'

### Como Funciona<IntroList />

### Período do Evento
* Período do evento: 27 de maio de 2026, às 00:00, a 25 de junho de 2026, às 23:59 (UTC+0).
* As contagens regressivas diárias, reinicializações de tarefas e disponibilidade de recompensas são baseadas em UTC+0.
* Após o término do evento, as caixas de bolo não resgatadas e os selos não utilizados expirarão. O sistema não os resgatará automaticamente.

### Caixas de Bolo Diárias
* As caixas de bolo podem ser resgatadas após a conclusão de 60 minutos de foco no respectivo dia. Isso inclui a caixa de bolo gratuita e a Caixa de Bolo Bônus Plus.
* As Caixas de Bolo Extras Diárias só podem ser adquiridas no dia atual. Datas passadas não podem ser compradas retroativamente.
* Os bolos ganhos durante o evento são desbloqueados permanentemente e ainda podem ser usados após o término do evento.
* Após assinar o Forest Plus durante o evento, você pode voltar às datas em que completou 60 minutos de foco e resgatar a Caixa de Bolo Bônus Plus para essas datas.
* As Caixas de Bolo Bônus não resgatadas ganhas enquanto sua assinatura Plus estava ativa ainda podem ser resgatadas durante o evento, even após a expiração da assinatura.

### Selos e Loja de Troca
* Quando você abre uma caixa de bolo, os bolos repetidos se transformam em selos.
* Os selos podem ser usados para resgatar os bolos que faltam.
* Os membros Plus podem usar selos para resgatar as Árvores de Volta durante o evento.

### Observações
* Cada dia do evento começa às 00:00 (UTC+0). Se uma sessão de foco ultrapassar essa virada de dia, o tempo de foco não será contabilizado para o evento.
* É proibido trapacear, abusar de bugs ou usar outros métodos inadequados. As violações podem resultar em desclassificação do evento ou remoção de recompensas.
* O Forest reserva-se o direito de ajustar, suspender ou encerrar o evento e de fazer a interpretação final das regras do evento.

### Taxas de Recompensa
As seguintes taxas se aplicam a todas as caixas de bolo. Cada caixa de bolo concede 1 recompensa. Se você receber uma recompensa repetida, ela será convertida em selos de acordo com a tabela abaixo:


| Recompensa | Estilos | Taxa por Estilo | Conversão em Selos |
| --- | --- | --- | --- |
| <PrizeCol gids=${i?.["[169]"]} label="Árvore Bolo de 12º Aniversário" /> | 1 | 4.5% | 30 |
| <PrizeCol gids=${i?.["[170, 171, 172, 173, 174]"]} label="" /> | 5 | 9.55% | 12 |
| <PrizeCol gids=${i?.["[164, 165, 166, 167, 168]"]} label="" /> | 5 | 9.55% | 12 |`)
};

const ru_bakery_event_rule = /** @type {(inputs: Bakery_Event_RuleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`import ${i?.[" PrizeCol, IntroList "]} from '../components'

### Как это работает<IntroList />

### Период события
* Период события: с 27 мая 2026 года, 00:00, по 25 июня 2026 года, 23:59 (UTC+0).
* Ежедневный обратный отсчет, сброс заданий и доступность наград основаны на времени UTC+0.
* После окончания события неполученные коробки с тортом и неиспользованные штампы сгорят. Система не заберет их автоматически.

### Ежедневные коробки с тортом
* Коробки с тортом можно получить после завершения 60 минут фокусировки в этот день. Сюда входят как бесплатная коробка с тортом, так и бонусная коробка с тортом Plus.
* Ежедневные дополнительные коробки с тортом можно приобрести только в текущий день. Прошедшие даты нельзя приобрести задним числом.
* Торты, заработанные во время события, открываются навсегда, и их можно использовать даже после окончания события.
* Оформив подписку Forest Plus во время события, вы можете вернуться к датам, когда вы завершили 60 минут фокусировки, и забрать бонусную коробку с тортом Plus за эти дни.
* Неполученные бонусные коробки с тортом, заработанные во время действия вашей подписки Plus, все еще можно забрать во время события, даже после истечения срока действия подписки.

### Штампы и магазин обмена
* Когда вы открываете коробку с тортом, повторяющиеся торты превращаются в штампы.
* Штампы можно использовать, чтобы получить недостающие торты.
* Участники Plus могут использовать штампы, чтобы получить возвращающиеся деревья во время события.

### Примечания
* Каждый день события начинается в 00:00 (UTC+0). Если сессия фокусировки пересекает эту смену дня, время фокусировки не будет засчитано в событии.
* Мошенничество, злоупотребление ошибками или использование других ненадлежащих методов запрещено. Нарушения могут привести к дисквалификации из события или аннулированию наград.
* Forest оставляет за собой право изменять, приостанавливать или прекращать событие, а также выносить окончательное решение по интерпретации правил события.

### Шансы на награды
Следующие шансы применимы ко всем коробкам с тортом. Каждая коробка с тортом дает 1 награду. Если вы получите повторяющуюся награду, она будет конвертирована в штампы в соответствии с таблицей ниже:


| Награда | Стили | Шанс на стиль | Конвертация в штампы |
| --- | --- | --- | --- |
| <PrizeCol gids=${i?.["[169]"]} label="Торт-дерево на 12-ю годовщину" /> | 1 | 4.5% | 30 |
| <PrizeCol gids=${i?.["[170, 171, 172, 173, 174]"]} label="" /> | 5 | 9.55% | 12 |
| <PrizeCol gids=${i?.["[164, 165, 166, 167, 168]"]} label="" /> | 5 | 9.55% | 12 |`)
};

const th_bakery_event_rule = /** @type {(inputs: Bakery_Event_RuleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`import ${i?.[" PrizeCol, IntroList "]} from '../components'

### วิธีการร่วมสนุก<IntroList />

### ช่วงเวลากิจกรรม
* ช่วงเวลากิจกรรม: 27 พฤษภาคม 2026 เวลา 00:00 น. ถึง 25 มิถุนายน 2026 เวลา 23:59 น. (UTC+0)
* การนับถอยหลังรายวัน การรีเซ็ตภารกิจ และการเปิดให้รับรางวัลจะยึดตามเวลา UTC+0 เป็นหลัก
* หลังจากสิ้นสุดกิจกรรม กล่องเค้กที่ยังไม่ได้กดรับและแสตมป์ที่ไม่ได้ใช้งานจะหมดอายุ ระบบจะไม่กดรับให้โดยอัตโนมัติ

### กล่องเค้กรายวัน
* สามารถรับกล่องเค้กได้หลังจากสะสมเวลาโฟกัสครบ 60 นาทีในวันนั้นๆ ซึ่งรวมถึงกล่องเค้กฟรีและกล่องเค้กโบนัส Plus
* กล่องเค้กพิเศษรายวันสามารถซื้อได้ในวันปัจจุบันเท่านั้น ไม่สามารถซื้อย้อนหลังสำหรับวันที่ผ่านมาได้
* เค้กที่ได้รับในช่วงเวลากิจกรรมจะปลดล็อกอย่างถาวร และยังสามารถใช้งานได้หลังจากสิ้นสุดกิจกรรม
* หลังจากสมัครสมาชิก Forest Plus ในช่วงเวลากิจกรรม คุณสามารถย้อนกลับไปยังวันที่คุณสะสมเวลาโฟกัสครบ 60 นาทีเพื่อรับกล่องเค้กโบนัส Plus สำหรับวันเหล่านั้นได้
* กล่องเค้กโบนัสที่ยังไม่ได้กดรับซึ่งได้รับในขณะที่สมาชิก Plus ของคุณยังมีผลอยู่ ยังคงสามารถกดรับได้ในช่วงเวลากิจกรรม แม้ว่าสมาชิกของคุณจะหมดอายุแล้วก็ตาม

### แสตมป์และร้านค้าแลกรับ
* เมื่อคุณเปิดกล่องเค้ก เค้กที่ซ้ำกันจะเปลี่ยนเป็นแสตมป์
* สามารถใช้แสตมป์เพื่อแลกรับเค้กที่ยังไม่มีได้
* สมาชิก Plus สามารถใช้แสตมป์เพื่อแลกรับต้นไม้ที่กลับมาได้ในช่วงเวลากิจกรรม

### หมายเหตุ
* วันกิจกรรมแต่ละวันจะเริ่มต้นใหม่เวลา 00:00 น. (UTC+0) หากช่วงเวลาโฟกัสคาบเกี่ยวข้ามเวลาเปลี่ยนวันดังกล่าว เวลาโฟกัสนั้นจะไม่ถูกนับรวมในกิจกรรม
* ห้ามทำการโกง ละเมิดช่องโหว่ หรือใช้วิธีการที่ไม่เหมาะสมอื่นๆ การฝ่าฝืนอาจส่งผลให้ถูกตัดสิทธิ์จากกิจกรรมหรือถูกยึดรางวัลคืน
* Forest ขอสงวนสิทธิ์ในการปรับเปลี่ยน ระงับ หรือยุติกิจกรรม และสิทธิ์ในการตีความกฎกติกาของกิจกรรมเป็นขั้นสุดท้าย

### อัตราการรับรางวัล
อัตราต่อไปนี้จะใช้กับกล่องเค้กทั้งหมด กล่องเค้กแต่ละกล่องจะมอบรางวัล 1 ชิ้น หากคุณได้รับรางวัลที่ซ้ำกัน รางวัลนั้นจะถูกเปลี่ยนเป็นแสตมป์ตามตารางด้านล่างนี้:


| รางวัล | รูปแบบ | อัตราต่อรูปแบบ | การเปลี่ยนเป็นแสตมป์ |
| --- | --- | --- | --- |
| <PrizeCol gids=${i?.["[169]"]} label="ต้นเค้กฉลองครบรอบ 12 ปี" /> | 1 | 4.5% | 30 |
| <PrizeCol gids=${i?.["[170, 171, 172, 173, 174]"]} label="" /> | 5 | 9.55% | 12 |
| <PrizeCol gids=${i?.["[164, 165, 166, 167, 168]"]} label="" /> | 5 | 9.55% | 12 |`)
};

const tr_bakery_event_rule = /** @type {(inputs: Bakery_Event_RuleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`import ${i?.[" PrizeCol, IntroList "]} from '../components'

### Nasıl Çalışır<IntroList />

### Etkinlik Dönemi
* Etkinlik dönemi: 27 Mayıs 2026, 00:00 - 25 Haziran 2026, 23:59 (UTC+0).
* Günlük geri sayımlar, görev sıfırlamaları ve ödül kullanılabilirliği UTC+0'a dayanır.
* Etkinlik sona erdikten sonra, alınmayan pasta kutuları ve kullanılmayan pulların süresi dolacaktır. Sistem bunları otomatik olarak almayacaktır.

### Günlük Pasta Kutuları
* Pasta kutuları, o gün için 60 dakikalık odaklanma tamamlandıktan sonra alınabilir. Buna hem ücretsiz pasta kutusu hem de Plus Bonus Pasta Kutusu dahildir.
* Günlük Ek Pasta Kutuları yalnızca içinde bulunulan günde satın alınabilir. Geçmiş tarihler geriye dönük olarak satın alınamaz.
* Etkinlik sırasında kazanılan pastaların kilidi kalıcı olarak açılır ve etkinlik sona erdikten sonra da kullanılmaya devam edilebilir.
* Etkinlik sırasında Forest Plus'a abone olduktan sonra, 60 dakikalık odaklanmayı tamamladığınız tarihlere geri dönebilir ve o tarihler için Plus Bonus Pasta Kutusu'nu alabilirsiniz.
* Plus üyeliğiniz etkinken kazanılan ancak alınmayan Bonus Pasta Kutuları, üyeliğiniz sona erse bile etkinlik sırasında alınabilir.

### Pullar ve Takas Mağazası
* Bir pasta kutusu açtığınızda, yinelenen pastalar pula dönüşür.
* Eksik pastaları almak için pullar kullanılabilir.
* Plus üyeleri, etkinlik sırasında geri dönen ağaçları almak için pulları kullanabilir.

### Notlar
* Her etkinlik günü 00:00'da (UTC+0) başlar. Bir odaklanma oturumu bu gün değişimini aşarsa, odaklanma süresi etkinliğe sayılmayacaktır.
* Hile yapmak, hataları kötüye kullanmak veya diğer uygunsuz yöntemleri kullanmak yasaktır. İhlaller, etkinlikten diskalifiye edilmeye veya ödüllerin kaldırılmasına neden olabilir.
* Forest, etkinliği ayarlama, askıya alma veya sonlandırma ve etkinlik kurallarının nihai yorumunu yapma hakkını saklı tutar.

### Ödül Oranları
Aşağıdaki oranlar tüm pasta kutuları için geçerlidir. Her pasta kutusu 1 ödül verir. Yinelenen bir ödül alırsanız, aşağıdaki tabloya göre pula dönüştürülecektir:


| Ödül | Stiller | Stil Başına Oran | Pul Dönüşümü |
| --- | --- | --- | --- |
| <PrizeCol gids=${i?.["[169]"]} label="12. Yıl Dönümü Pasta Ağacı" /> | 1 | 4.5% | 30 |
| <PrizeCol gids=${i?.["[170, 171, 172, 173, 174]"]} label="" /> | 5 | 9.55% | 12 |
| <PrizeCol gids=${i?.["[164, 165, 166, 167, 168]"]} label="" /> | 5 | 9.55% | 12 |`)
};

const zh_cn_bakery_event_rule = /** @type {(inputs: Bakery_Event_RuleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`import ${i?.[" PrizeCol, IntroList "]} from '../components'

### 活动方式<IntroList />

### 活动期间
* 活动期间：2026/05/27 00:00 至 2026/06/25 23:59（UTC+0）。
* 每日倒数、任务重置与奖励开放时间皆以 UTC+0 为准。
* 活动结束后，未领取的蛋糕礼盒和未使用的印花都将失效，系统不会自动领取。

### 每日蛋糕礼盒
* 蛋糕礼盒需完成当日 60 分钟专注后才开放领取，包含免费及 Plus 会员加码蛋糕礼盒。
* 每日额外蛋糕礼盒仅限当日购买；过去日期不开放补买。
* 活动期间获得的蛋糕将永久解锁，活动结束后仍可使用。
* 活动期间订阅 Forest Plus 后，可回到已完成 60 分钟专注的日期，领取该日的 Plus 加码蛋糕礼盒。
* 若在 Plus 会员期间已有符合领取条件但尚未领取的加码蛋糕礼盒，即使 Plus 会员到期，仍可于活动期间内领取。

### 印花与兑换商店
* 开启蛋糕礼盒时，若获得重复蛋糕，即可获得印花。
* 印花可用于兑换尚未获得的蛋糕。
* Plus 会员可于活动期间使用印花兑换返场树种。

### 注意事项
* 活动以每日 00:00（UTC+0）为换日点。若专注时段跨越换日点，该次专注时间将不会计入活动。
* 禁止作弊、滥用漏洞或其他不正当行为；违规者可能被取消活动资格或回收奖励。
* Forest 保留调整、暂停、终止活动内容及最终解释之权利。

### 奖品概率
以下概率适用于所有蛋糕礼盒。每个蛋糕礼盒开启后可获得 1 个奖励；若获得已拥有的重复奖励，将依下表转换为印花：


| 奖品内容 | 款数 | 每款概率 | 转换印花 |
| --- | --- | --- | --- |
| <PrizeCol gids=${i?.["[169]"]} label="十二周年蛋糕树" /> | 1 | 4.5% | 30 |
| <PrizeCol gids=${i?.["[170, 171, 172, 173, 174]"]} label="12 周年纸杯蛋糕" /> | 5 | 9.55% | 12 |
| <PrizeCol gids=${i?.["[164, 165, 166, 167, 168]"]} label="12 周年马卡龙" /> | 5 | 9.55% | 12 |`)
};

const zh_tw_bakery_event_rule = /** @type {(inputs: Bakery_Event_RuleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`import ${i?.[" PrizeCol, IntroList "]} from '../components'

### 活動方式
<IntroList />

### 活動期間
* 活動期間：2026/05/27 00:00 至 2026/06/25 23:59（UTC+0）。
* 每日倒數、任務重置與獎勵開放時間皆以 UTC+0 為準。
* 活動結束後，未領取的蛋糕禮盒和未使用的印花都將失效，系統不會自動領取。

### 每日蛋糕禮盒
* 蛋糕禮盒需完成當日 60 分鐘專注後才開放領取，包含免費及 Plus 會員加碼蛋糕禮盒。
* 每日額外蛋糕禮盒僅限當日購買；過去日期不開放補買。
* 活動期間獲得的蛋糕將永久解鎖，活動結束後仍可使用。
* 活動期間訂閱 Forest Plus 後，可回到已完成 60 分鐘專注的日期，領取該日的 Plus 加碼蛋糕禮盒。
* 若在 Plus 會員期間已有符合領取條件但尚未領取的加碼蛋糕禮盒，即使 Plus 會員到期，仍可於活動期間內領取。

### 印花與兌換商店
* 開啟蛋糕禮盒時，若獲得重複蛋糕，即可獲得印花。
* 印花可用於兌換尚未獲得的蛋糕。
* Plus 會員可於活動期間使用印花兌換回歸樹種。

### 注意事項
* 活動以每日 00:00（UTC+0）為換日點。若專注時段跨越換日點，該次專注時間將不會計入活動。
* 禁止作弊、濫用漏洞或其他不正當行為；違規者可能被取消活動資格或回收獎勵。
* Forest 保留調整、暫停、終止活動內容及最終解釋之權利。

### 獎品機率
以下機率適用於所有蛋糕禮盒。每個蛋糕禮盒開啟後可獲得 1 個獎勵；若獲得已擁有的重複獎勵，將依下表轉換為印花：


| 獎品內容 | 款數 | 每款機率 | 轉換印花 |
| --- | --- | --- | --- |
| <PrizeCol gids=${i?.["[169]"]} label="十二週年蛋糕樹" /> | 1 | 4.5% | 30 |
| <PrizeCol gids=${i?.["[170, 171, 172, 173, 174]"]} label="12 週年杯子蛋糕" /> | 5 | 9.55% | 12 |
| <PrizeCol gids=${i?.["[164, 165, 166, 167, 168]"]} label="12 週年馬卡龍" /> | 5 | 9.55% | 12 |`)
};

/**
* | output |
* | --- |
* | "import { PrizeCol, IntroList } from '../components' ### How it Works <IntroList /> ### Event Period * Event period: May 27, 2026, 00:00 to June 25, 2026, 23:..." |
*
* @param {Bakery_Event_RuleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const bakery_event_rule = /** @type {((inputs: Bakery_Event_RuleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bakery_Event_RuleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bakery_event_rule(inputs)
	if (locale === "ar") return ar_bakery_event_rule(inputs)
	if (locale === "de") return de_bakery_event_rule(inputs)
	if (locale === "es") return es_bakery_event_rule(inputs)
	if (locale === "fr") return fr_bakery_event_rule(inputs)
	if (locale === "it") return it_bakery_event_rule(inputs)
	if (locale === "ja") return ja_bakery_event_rule(inputs)
	if (locale === "ko") return ko_bakery_event_rule(inputs)
	if (locale === "pt_br") return pt_br_bakery_event_rule(inputs)
	if (locale === "ru") return ru_bakery_event_rule(inputs)
	if (locale === "th") return th_bakery_event_rule(inputs)
	if (locale === "tr") return tr_bakery_event_rule(inputs)
	if (locale === "zh_cn") return zh_cn_bakery_event_rule(inputs)
	return zh_tw_bakery_event_rule(inputs)
});